import React from 'react';
import ReactDOM from 'react-dom';
import { root } from 'baobab-react/higher-order';
import { Router, browserHistory, match } from 'react-router';
import tree from './state';
import createRoutes from './routes';
import './resources/css/main.css';

const mountNode = document.getElementById('root');
const history = browserHistory;
const routes = createRoutes();

match({ history, routes }, (error, redirectLocation, renderProps) => {
	const App = () => (<Router onUpdate={() => window.scrollTo(0, 0)} history={ history } { ...renderProps } />);
	const RootedApp = root(tree, App);
	ReactDOM.render(<RootedApp />, mountNode);
});


// WEBPACK FOOTER //
// ./src/index.js